<section class="portal-dashboard">
  <header class="portal-dashboard-head">
    <div class="portal-dashboard-title-block">
      <p class="portal-dashboard-eyebrow">Superadmin</p>
      <h1>Yönetim paneli</h1>
      <p class="portal-dashboard-subtitle">
        Portal yönetim alanları. Ortak oturum ve yetkilendirme account üzerinden çalışır.
      </p>
    </div>
    <div class="portal-dashboard-stat" aria-label="Yönetim alanı sayısı">
      <span class="portal-dashboard-stat-value">{{ resources.length }}</span>
      <span class="portal-dashboard-stat-label">alan</span>
    </div>
  </header>

  <div class="resource-grid">
    @for (resource of resources; track resource.id) {
    <a class="resource-card" [routerLink]="['/', resource.route]">
      <span class="resource-card-icon" aria-hidden="true">
        <span class="material-icons">{{ resource.icon }}</span>
      </span>
      <div class="resource-card-copy">
        <h2>{{ resource.title }}</h2>
        <p>{{ resource.description }}</p>
      </div>
      <span class="resource-card-arrow" aria-hidden="true">→</span>
    </a>
    }
  </div>
</section>
